import { render, staticRenderFns } from "./stakeholderLists.vue?vue&type=template&id=3f61f0d6&scoped=true&"
import script from "./stakeholderLists.vue?vue&type=script&lang=js&"
export * from "./stakeholderLists.vue?vue&type=script&lang=js&"
import style0 from "./stakeholderLists.vue?vue&type=style&index=0&id=3f61f0d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f61f0d6",
  null
  
)

export default component.exports